'use client';

import {
  Box,
  Button,
  Modal,
  SystemIcon,
  Typography,
} from '@wishket/design-system';
import { usePathname } from 'next/navigation';

import { Icon, Link } from '@/shared/Components';
import { PATH } from '@/shared/constants';
import { useDeviceCheck } from '@/shared/hooks';

interface AskAIQuestionRestrictionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const Content = ({
  onClose,
}: Pick<AskAIQuestionRestrictionModalProps, 'onClose'>) => {
  const pathname = usePathname();

  return (
    <Box className="flex w-full flex-col items-center gap-4 p-5 pb-10 desktop:p-8">
      <Box className="relative flex w-full justify-center">
        <Icon name="guide_heart" />
        <button
          className="absolute right-0 top-0 hidden desktop:block"
          onClick={onClose}
          data-testid="question-restriction-modal-close-button"
        >
          <SystemIcon name="large_delete" className="text-w-gray-600" />
        </button>
      </Box>
      <Box className="flex w-full flex-col items-center gap-6 desktop:gap-8">
        <Typography
          variant="subTitle2"
          className="whitespace-pre-line font-medium text-w-gray-900"
        >
          {`물어보기(3회)를 모두 사용했어요.\n가입 후 무제한으로 이용해 보세요.`}
        </Typography>
        <Box className="flex w-full flex-col  items-center gap-6">
          <Link
            href={`${PATH.AUTH_SIGNUP}?next=${pathname}`}
            className="w-full"
            data-testid="question-restriction-modal-signup-link"
          >
            <Button variant="solid" className="w-full">
              회원가입
            </Button>
          </Link>
          <Box className="flex gap-1">
            <Typography variant="body1" className="text-w-gray-600">
              이미 위시켓 통합회원이신가요?
            </Typography>
            <Link
              href={`${PATH.AUTH_LOGIN}?next=${pathname}`}
              data-testid="question-restriction-modal-login-link"
            >
              <Typography
                variant="body1"
                className="font-medium text-primary hover:underline"
              >
                로그인
              </Typography>
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const AskAIQuestionRestrictionModal = ({
  isOpen,
  onClose,
}: AskAIQuestionRestrictionModalProps) => {
  const { isDesktop } = useDeviceCheck();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      variant={isDesktop ? 'default' : 'bottom'}
      size="sm"
      isFixedHeight={false}
    >
      <Content onClose={onClose} />
    </Modal>
  );
};

export default AskAIQuestionRestrictionModal;
